import { Spin } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileDetailsActions } from "redux/actions/UserProfile/getUserProfileDetailsActions";
import { RootState } from "redux/rootReducer";

interface ProfileProps {}

const Profile = ({}: ProfileProps) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { userId } = useSelector((state: RootState) => state.loginReducer);

  useEffect(() => {
    dispatch(getUserProfileDetailsActions(userId));
  }, []);

  const { getUserDetailsLoading, userDetailsData } = useSelector(
    (state: RootState) => state.getUserProfileDetailsReducer
  );

  console.log(userDetailsData);

  return (
    <section className="w-full">
      <Spin spinning={getUserDetailsLoading}>
        <form className="w-full h-full flex flex-col gap-4">
          {/* user data section  ==============*/}
          <div className="flex flex-col xl:flex-row  gap-8">
            {/* personal data section  ==============*/}
            <div className="p-[20px] w-full bg-white rounded-[20px] shadow-shadow_profile flex flex-col gap-3">
              <p className="text-second_color text-[18px] font-[500]">
                Personal Data
              </p>
              {/* row one ================= */}
              <div className="flex items-center gap-3">
                {/* Giver # =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Giver #
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>

                {/* Contact Type =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444]  font-[500]">
                    Giver Name
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>
              </div>

              {/* row two ================= */}
              <div className="flex items-center gap-3">
                {/* Account # =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Account #
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>

                {/* Starting Date =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Starting Date
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>
              </div>

              {/* row three ================= */}
              <div className="flex items-center gap-3">
                {/* Payment Method =============*/}
                <div className="w-full flex flex-col gap-2">
                  <p className="text-[14px] text-[#444444]">Payment Method</p>
                  <div className="flex items-center gap-3">
                    <label
                      htmlFor="Bank"
                      className="flex items-center gap-1 text-[13px] text-[#808184]"
                    >
                      <input name="method" id="Bank" type="radio" />
                      Bank
                    </label>

                    <label
                      htmlFor="Cheque"
                      className="flex items-center gap-1 text-[13px] text-[#808184]"
                    >
                      <input name="method" id="Cheque" type="radio" />
                      Cheque
                    </label>

                    <label
                      htmlFor="Cash"
                      className="flex items-center gap-1 text-[13px] text-[#808184]"
                    >
                      <input name="method" id="Cash" type="radio" />
                      Cash
                    </label>
                  </div>
                </div>

                {/* Bank Name =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Bank Name
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>
              </div>
            </div>

            {/* contact data  ======================*/}
            <div className="p-[20px] w-full bg-white rounded-[20px] shadow-shadow_profile flex flex-col gap-3">
              <p className="text-second_color text-[18px] font-[500]">
                Contact Data
              </p>
              {/* row one ================= */}
              <div className="flex items-center gap-3">
                {/* Phone # =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Phone #
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>

                {/* Emirate =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444]  font-[500]">
                    Emirate
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>
              </div>

              {/* row two ================= */}
              <div className="flex items-center gap-3">
                {/* Address =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Address
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>

                {/* Account # =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Account #
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>
              </div>

              {/* row three ================= */}
              <div className="flex items-center gap-3">
                {/* Email =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444]">Email</p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>

                {/* Contact Type =============*/}
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[14px] text-[#444444] font-[500]">
                    Contact Type
                  </p>
                  <input
                    type="text"
                    className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* submit button */}
          <div className="flex items-center justify-end">
            <button
              type="submit"
              className={` h-[32px] bg-first_color text-white text-[13px] lg:text-[16px] ${
                i18n.language === "en" ? "font-Poppins " : "font-Almarai "
              } font-[600] rounded-[10px] hover:bg-[#614629] duration-300 px-[30px] `}
            >
              Update data
            </button>
          </div>
        </form>
      </Spin>
    </section>
  );
};

export default Profile;
